import { render } from "./FindMachineID.vue?vue&type=template&id=4c887f72"
const script = {}
script.render = render

export default script